import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class Delete extends Component {
    render() {
        const { deleteModal, close } = this.props;
        return (
            <Modal
                centered
                bsSize="small"
                className="Delete-modal"
                show={deleteModal}
                onHide={close}
            >
                <Modal.Header className="header">
                    <Modal.Title className="title">Are you sure you want to remove your tutoring application</Modal.Title>
                    <button
                        onClick={close}
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        className="close"
                        >
                            <span className="x">x</span>
                        </button>

                </Modal.Header>
                <Modal.Body className="body">
                    <p className="sub-title">You won't be able to find or edit your tutoring application, and you would have to reapply and provide us with all supporting documents to tutor in the future</p>
                </Modal.Body>
                <Modal.Footer className="footer">
                    <button
                        className="cancel"
                        onClick={close}
                    >
                        Cancel
                    </button>
                    <button
                        className="confirm"
                        onClick={close}
                    >
                        Confirm
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default Delete;